import { Link } from "react-router-dom";
import { Calendar, MapPin, Images } from "lucide-react";
import { thumbUrl, fmtDate, brl, CATEGORIES } from "@/lib/api";

const FALLBACK = "https://images.unsplash.com/photo-1497316730643-415fac54a2af?w=900&q=80";

export function EventCard({ event, large }) {
  const cover = event.cover_photo_id ? thumbUrl(event.cover_photo_id) : FALLBACK;
  return (
    <Link
      to={`/evento/${event.id}`}
      data-testid={`event-card-${event.id}`}
      className={`group relative block overflow-hidden border border-zinc-200 rounded-lg bg-zinc-100 hover:-translate-y-1 hover:shadow-xl transition-[transform,box-shadow] duration-300 ${large ? "min-h-[360px]" : "min-h-[280px]"}`}
    >
      <img
        src={cover}
        alt={event.name}
        className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
      <span className="absolute top-4 left-4 label-caps bg-white text-zinc-900 px-2.5 py-1 rounded">
        {CATEGORIES[event.category] || event.category}
      </span>
      <div className="absolute bottom-0 left-0 right-0 p-5 text-white">
        <h3 className={`font-display font-bold tracking-tight leading-tight ${large ? "text-3xl" : "text-xl"}`}>{event.name}</h3>
        <div className="mt-3 flex flex-wrap gap-x-4 gap-y-1 text-sm text-white/85">
          <span className="flex items-center gap-1.5"><Calendar className="w-4 h-4" />{fmtDate(event.date)}</span>
          {event.location && <span className="flex items-center gap-1.5"><MapPin className="w-4 h-4" />{event.location}</span>}
          <span className="flex items-center gap-1.5"><Images className="w-4 h-4" />{event.photo_count} fotos</span>
        </div>
        <div className="mt-3 text-sm font-semibold">{brl(event.price)} por foto</div>
      </div>
    </Link>
  );
}
